import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const HtmlViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="HTML Viewer for Android — Render & Inspect HTML Files on Mobile | Cosmovex"
    metaDescription="View and render HTML files on Android without a laptop. Syntax highlighting, source inspector, offline support. Download HTMLVEdit free on Google Play."
    ogTitle="HTML Viewer for Android — HTMLVEdit"
    h1="HTML Viewer for Android"
    intro="Open any HTML file on your Android phone and see it rendered instantly. HTMLVEdit gives you a full HTML viewer with source inspector, syntax highlighting, and offline support — no browser hacks needed."
    paragraphs={[
      "HTML files show up everywhere — downloaded templates, web project assets, email mockups, saved web pages. Most Android file managers just show raw text. HTMLVEdit renders HTML as a proper web page and lets you switch between the rendered view and the source code with one tap.",
      "The built-in source viewer applies syntax highlighting to HTML tags, attributes, and values so the structure is immediately readable. You can collapse and expand nested elements, search within the source, and copy any portion to the clipboard. It handles malformed HTML gracefully rather than failing silently.",
      "Everything works offline. There's no server processing your files and no internet connection required to view or edit them. This matters when you're on a plane reviewing project files, debugging a downloaded template, or working in a location with poor connectivity.",
      "Developers and designers who work with HTML on the go find HTMLVEdit especially useful for quick reviews. You can open a file directly from your Downloads folder, cloud storage, or any file manager — check the markup, make a small edit, and save without touching a computer. It's the HTML viewer Android has always needed.",
    ]}
    features={[
      "Render HTML files as web pages in the built-in viewer",
      "Toggle between rendered view and source code instantly",
      "Syntax highlighting for tags, attributes, and values",
      "Collapsible element tree for easier navigation",
      "Search within HTML source with match highlighting",
      "Edit HTML directly and preview changes in real-time",
      "Open files from any file manager or cloud storage",
      "Works fully offline — no internet connection required",
      "Handles large HTML files without crashing",
      "Copy, share, or export edited HTML files",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.htmlvedit"
    icon="/images/htmlvedit.png"
    appName="HTMLVEdit"
    accentColor="#A8720E"
    canonicalPath="/html-viewer-android"
  />
);

export default HtmlViewerAndroid;
